import axios from "axios";
import { handleRequest } from "./handler";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import Router from "next/router";
import API_MANAGER from "../Api";

axios.defaults.headers.post["Content-Type"] = "application/json";

let HELPERS = {
  getCookie: (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  },

  request: (config) => {
    config.headers = config.headers ? config.headers : {};
    const csrfTokenEl = document.querySelector("[name=csrfmiddlewaretoken]");
    const csrfToken =
      HELPERS.getCookie("csrftoken") || (csrfTokenEl && csrfTokenEl.value);
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    return axios
      .request(config)
      .then((response) => {
        if (response.data.message == "Token not valid") {
          deleteCookie("access_token");
          deleteCookie("refresh_token");
          Router.push("/login");
        } else {
          return response;
        }
      })
      .catch((err) => {
        handleRequest(err);
        throw err;
      });
  },
  secureRequest: async (config) => {
    config.headers = config.headers || {};
    const access_token = getCookie("access_token");
    const refresh_token = getCookie("refresh_token");

    if (!refresh_token || (!refresh_token && !access_token)) {
      if (typeof window !== "undefined") {
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(
              /=.*/,
              "=;expires=" + new Date().toUTCString() + ";path=/",
            );
        });
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      }
      return Promise.reject("No tokens found. Redirecting to login.");
    }

    if (access_token) {
      config.headers["Authorization"] = `Bearer ${access_token}`;
      return HELPERS.request(config);
    }

    try {
      const res = await API_MANAGER.refreshToken({ refresh_token });
      const data = await res.json();

      if (data.status === "success") {
        const newAccessToken = data.data.access_token;
        const newRefreshToken = data.data.refresh_token;

        setCookie("access_token", newAccessToken, {
          maxAge: 60 * 50,
          secure: true,
        });
        setCookie("refresh_token", newRefreshToken, {
          maxAge: 60 * 60 * 24,
          secure: true,
        });

        config.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return HELPERS.request(config);
      } else {
        throw new Error("Failed to refresh token.");
      }
    } catch (err) {
      console.error("Token refresh failed:", err);
      if (typeof window !== "undefined") {
        deleteCookie("access_token");
        deleteCookie("refresh_token");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      }
      return Promise.reject("Authentication failed. Redirecting to login.");
    }
  },

  convertToFormData: (obj, rootName, ignoreList) => {
    var formData = new FormData();
    function appendFormData(data, root) {
      if (!ignore(root)) {
        root = root || "";
        if (data instanceof File) {
          formData.append(root, data);
        } else if (Array.isArray(data)) {
          for (var i = 0; i < data.length; i++) {
            appendFormData(data[i], root + "[" + i + "]");
          }
        } else if (typeof data === "object" && data) {
          for (var key in data) {
            if (data.hasOwnProperty(key)) {
              if (root === "") {
                appendFormData(data[key], key);
              } else {
                appendFormData(data[key], root + "." + key);
              }
            }
          }
        } else {
          if (data !== null && typeof data !== "undefined") {
            formData.append(root, data);
          }
        }
      }
    }
    function ignore(root) {
      return (
        Array.isArray(ignoreList) &&
        ignoreList.some(function (x) {
          return x === root;
        })
      );
    }
    appendFormData(obj, rootName);
    return formData;
  },
  numberWithCommas: (x) => {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  // numberWithCommasAndDecimal: (x) => {
  //   if (typeof x !== "number") return "";

  //   let [integerPart, decimalPart] = x.toString().split(".");

  //   if (decimalPart) {
  //     decimalPart = Math.round(parseFloat(`0.${decimalPart}`) * 100).toString();
  //     if (decimalPart.length < 2) {
  //       decimalPart = decimalPart.padEnd(2, "0");
  //     }
  //     decimalPart = "." + decimalPart;
  //   } else {
  //     decimalPart = "";
  //   }

  //   integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  //   return integerPart + decimalPart;
  // },

  numberWithCommasAndDecimal: (x) => {
    if (typeof x !== "number") return "";

    const hasDecimal = x % 1 !== 0;

    return x.toLocaleString("en-US", {
      minimumFractionDigits: hasDecimal ? 2 : 0,
      maximumFractionDigits: 2,
    });
  },

  getDisplayAmountValue: (x) => {
    const num = Number(x);
    if (!Number.isFinite(num)) return 0;

    const hasDecimal = num % 1 !== 0;

    return Number(
      num.toLocaleString("en-US", {
        minimumFractionDigits: hasDecimal ? 2 : 0,
        maximumFractionDigits: 2,
        useGrouping: false,
      }),
    );
  },
};

export default HELPERS;
